import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=18ea4106"
import script from "./PageButton.vue?vue&type=script&lang=ts"
export * from "./PageButton.vue?vue&type=script&lang=ts"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=18ea4106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports